<template>
  <v-container
    class="mb-12"
  >
    <v-row
      align="center"
      justify="center"
      class="text-center mb-4"
    >
      <v-col>
        <v-icon x-large>
          mdi-gavel
        </v-icon>
        <h2 class="display-2">
          Allgemeine Geschäfts&shy;bedingungen
        </h2>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        sm="10"
      >
        <v-card>
          <v-card-text>
            <ol>
              <li>
                <b>Geltungsbereich</b>
                <ol>
                  <li>
                    Nico Grundmann (nachfolgend "Betreiber") bietet die Nutzung der Website kegelmanager.de (nachfolgend "Website") und des Online-Spiels Kegelmanager (nachfolgend "KM") auf der Grundlage dieser Allgemeinen Geschäftsbedingungen an.
                  </li>
                  <li>
                    Andere oder entgegenstehende Bedingungen gelten auch dann nicht, wenn der Betreiber ihnen nicht ausdrücklich widerspricht.
                  </li>
                  <li>
                    Die Nutzung des KM zu kommerziellen Zwecken ist ausgeschlossen.
                  </li>
                </ol>
              </li>
              <li>
                <b>Vertragsabschluss</b>
                <ol>
                  <li>
                    Der Vertrag zwischen dem Betreiber und dem Nutzer kommt zustande, sobald der Betreiber den Antrag des Nutzers angenommen hat.
                  </li>
                  <li>
                    Die Einreichung des Antrages des Nutzers erfolgt durch die Verwendung des dafür vorgesehenen Online-Formulars.
                  </li>
                  <li>
                    Die Annahme erfolgt durch Zusendung einer Anmeldebestätigung an die vom Nutzer angegebene E-Mailadresse.
                  </li>
                </ol>
              </li>
              <li>
                <b>Leistungsinhalte</b>
                <ol>
                  <li>
                    Die Leistung des KM besteht aus der Bereitstellung der Website und damit der Funktionen des Spiels. Der Nutzer erhält das Nutzungsrecht an diesen Funktionen. Der Betreiber behält es sich ausdrücklich vor, beliebige Funktionen ohne gesonderte Ankündigung zu verändern, zu ergänzen oder zu entfernen. Ein Anrecht auf die Benutzung oder Beibehaltung bestimmter Funktionen besteht nicht.
                  </li>
                  <li>
                    Die Teilnahme am KM ist freiwillig und für den Benutzer kostenlos.
                  </li>
                  <li>
                    Der Nutzer wird im Spiel ggf. von dem Vorstand seines Clubs in seiner Funktion als Teammanager entlassen. Dies hat keinerlei Auswirkung auf den Status des Accounts des Nutzers.
                  </li>
                </ol>
              </li>
              <li>
                <b>Pflichten und Obliegenheiten des Nutzers</b>
                <ol>
                  <li>
                    Alle Teilnehmer dürfen nur einen Account haben. Der Betreiber behält sich das Recht vor, ohne Ankündigungen Nutzer mit mehreren Accounts aus dem Spielbetrieb auszuschließen. Dies gilt sowohl für kostenlose, als auch für kostenpflichtige Accounts.
                  </li>
                  <li>
                    Der Nutzer verpflichtet sich, keine rassistische, pornografische, provozierende, gewaltverherrlichende, beleidigende sowie sonstigen anstößige oder verbotene Inhalte in KM einzubringen. Ebenfalls ist es dem Nutzer untersagt, kommerzielle Werbung für Produkte bzw. Programme Dritter oder in unautorisierter Weise urheberrechtlich oder durch sonstige Rechte geschützte Werke Dritter einzubringen.
                  </li>
                  <li>
                    Die Übertragung eines Accounts auf Dritte bedarf der ausdrücklichen Zustimmung von dem Betreiber. Die Übertragung geschieht auf eigenes Risiko des Nutzers.
                  </li>
                  <li>
                    Es ist dem Nutzer untersagt, mit Hilfe von Geräten, Softwareprogrammen oder Diensten die technischen Maßnahmen zum Schutz von KM zu umgehen oder KM zu modifizieren oder umzustrukturieren.
                  </li>
                  <li>
                    Es ist dem Nutzer strengstens untersagt, Vereinsnamen und Logos zu verwenden, welche eine Lizenz der entsprechenden Verbände benötigen.
                  </li>
                  <li>
                    Bei Zuwiderhandlungen ist der Betreiber berechtigt, den Account des Nutzers zu sperren sowie alle Inhalte und Informationen, die von dem entsprechenden Nutzer stammen aus der Datenbank und von der Website zu entfernen.
                  </li>
                </ol>
              </li>
              <li>
                <b>Datenschutz</b>
                <ol>
                  <li>
                    Der Betreiber verpflichtet sich ausdrücklich zum Schutz der Privatsphäre der Nutzer. Für die Nutzung der Angebote von KM werden jedoch Daten benötigt und zwar die E-Mailadresse des Nutzers. Die Angabe weiterer Daten ist freiwillig. Die Daten werden im Zusammenhang mit der Registrierung erhoben und verarbeitet, in einer Datenbank gespeichert und zur Durchführung des Vertrages genutzt, jedoch nicht an Dritte weitergegeben.
                  </li>
                  <li>
                    Die E-Mailadresse des Nutzers wird zur Identifikation des Nutzers benötigt.
                  </li>
                  <li>
                    Der Betreiber wird mit allen Daten nach den strengen Regeln des Bundesdatenschutzgesetzes umgehen. Der Betreiber wird bei allen Maßnahmen die hohen Sicherheitsstandards des Teledienste-Datenschutzgesetzes und der Datenschutzverordnung für Telekommunikationsunternehmen sowie des Bundesdatenschutzgesetzes und sämtlicher sonstiger anwendbarer datenschutzrechtlicher Bestimmungen beachten.
                  </li>
                </ol>
              </li>
              <li>
                <b>Haftung</b>
                <ol>
                  <li>
                    Die Fehlerfreiheit von KM wird nicht zugesichert. Aus diesem Grunde muss der Nutzer damit rechnen, dass KM nicht in jeder Funktion fehlerfrei arbeitet.
                  </li>
                  <li>
                    Der KM übernimmt keinerlei Haftung für den Ausfall von Servern, für Programmierfehler und auf sonstige Weise entstehende Schäden.
                  </li>
                  <li>
                    Ein Anspruch auf die Wiederherstellung des Zustandes des Accounts vor Eintritt einer Störung besteht nicht.
                  </li>
                  <li>
                    Der Betreiber hat keinerlei Einfluss auf die Gestaltung und Inhalte von fremden Internetseiten, die außerhalb des Verantwortungsbereiches von dem Betreiber liegen. Der Betreiber erklärt daher ausdrücklich, dass keine Verantwortung für die entsprechenden verlinkten Seiten und deren Inhalt übernommen werden kann. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in von dem Betreiber eingerichteten Gästebüchern, Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist.
                  </li>
                  <li>
                    Der Betreiber ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken zu beachten, von ihm selbst erstellte Grafiken zu nutzen oder auf lizenzfreie Grafiken zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind. Das Copyright für veröffentlichte, von dem Betreiber selbst erstellte Grafiken bleibt allein bei dem Betreiber. Eine Vervielfältigung oder Verwendung solcher Grafiken in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung von dem Betreiber nicht gestattet.
                  </li>
                  <li>
                    KM bietet keine lizenzierten Markennamen oder Vereinslogos an. KM haftet nicht für eventuellen Missbrauch von lizenzierten bzw. Markennamen und Logos durch den Nutzer.
                  </li>
                </ol>
              </li>
              <li>
                <b>Gebühren</b>
                <ol>
                  <li>
                    Die Nutzung der Webseiten und des KM ist kostenlos.
                  </li>
                  <li>
                    Weitere Kosten, die z.B. für den Internetprovider anfallen, auf die der Betreiber keinen Einfluss hat, werden vom Nutzer getragen.
                  </li>
                </ol>
              </li>
              <li>
                <b>Schlussbestimmungen</b>
                <ol>
                  <li>
                    Änderungen und Ergänzungen des Nutzungsvertrages und / oder der Allgemeinen Geschäftsbedingungen sowie Nebenabreden bedürfen der Textform. Dies gilt auch für eine Abänderung des Textformerfordernisses.
                  </li>
                  <li>
                    Der Betreiber behält sich das Recht vor, diese Allgemeinen Geschäftsbedingungen jederzeit zu ändern oder zu erweitern. Eine Änderung oder Ergänzung wird in geeigneter Form mindestens 14 Tage vor Inkrafttreten bekannt gegeben. Die Bekanntgabe erfolgt in der Regel durch Veröffentlichung auf der Website. Der Nutzer hat nach Bekanntgabe und Kenntnisnahme die Gelegenheit, innerhalb einer 14-tägigen Frist den Änderungen gegenüber dem Betreiber zu widersprechen. Nach Ablauf der Frist gelten die geänderten Geschäftsbedingungen als akzeptiert und wirksam. Widerspricht der Nutzer fristgemäß, so ist der Betreiber berechtigt, den Vertrag zu dem Termin zu kündigen, zu dem die geänderten Geschäftsbedingungen in Kraft treten sollen.
                  </li>
                  <li>
                    Bei den auf der Website wiedergegebenen Kommentaren der Nutzer handelt es sich um für den Betreiber fremde Inhalte im Sinne von § 9 Abs. 1 Teledienste-Gesetz (TDG) und § 5 Abs. 3 Mediendienstestaatsvertrag (MDStV), die ausschließlich die persönliche Meinung des jeweiligen Nutzers wiedergeben. Der Betreiber ist für diese Inhalte in keiner Weise verantwortlich.
                  </li>
                  <li>
                    Für die vertraglichen Beziehungen der Parteien gilt ausschließlich deutsches Recht. Die Anwendung des UN-Kaufrechts ist ausgeschlossen.
                  </li>
                </ol>
              </li>
            </ol>
            <v-divider class="mt-4 mb-4" />
            <p>
              Stand 10.08.2017
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'AGB',
  metaInfo: {
    title: 'AGBs'
  }
}
</script>
